// react
import styled from 'styled-components';
import { Link } from 'react-router-dom';

// components
import { Chip, ChipProps } from '@/components/atoms';

/**
 * ChipGroup is a component that displays a group of chips.
 */
export const ChipGroup = ({ className, chips }: ChipGroupProps) => {
  if (!chips) return null;
  return (
    <Wrapper className={className}>
      {chips?.map((chip, i) => (
        <Link to={chip.to || '/'} key={i}>
          <Chip {...chip} />
        </Link>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.theme.spacing[8]};
  flex-wrap: wrap;
`;

interface ChipGroupProps {
  className?: string;
  chips?: ChipProps[];
}

ChipGroup.displayName = 'ChipGroup';

export default ChipGroup;
